var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPieChart = function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.01 2.778a.6.6 0 0 1 .48 1.1 8.837 8.837 0 0 0-4.897 10.737A8.84 8.84 0 0 0 13.74 20.64a8.84 8.84 0 0 0 6.42-5.225.6.6 0 0 1 1.106.466 10.037 10.037 0 0 1-12.132 5.703A10.037 10.037 0 0 1 2.16 10.137 10.04 10.04 0 0 1 8.01 2.778m5.015-.782a10.036 10.036 0 0 1 8.984 8.981v.001c.091.911-.659 1.6-1.493 1.6l-7.549.002a1.543 1.543 0 0 1-1.543-1.543V3.489c0-.834.689-1.584 1.601-1.493m-.12 1.194c-.124-.012-.281.091-.281.299v7.548a.345.345 0 0 0 .343.344l7.55-.001c.207 0 .31-.158.298-.283a8.834 8.834 0 0 0-7.53-7.861z"
  })));
};
export default SvgPieChart;